module.exports = __webpack_public_path__ + "img/button_name1_s.d132a844.png";